import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const routes =[
  	{
  	  	path: '/',
  	  	name: 'Home',
  	  	component:resolve => require(['@/pages/Home'],resolve)//路由按需加载
  	},
  	//列表
  	{
  	  	path: '/List',
  	  	name: 'List',
  	  	component:resolve => require(['@/pages/List'],resolve)
  	},
  	//详情
  	{
  	  	path: '/Detail',
  	  	name: 'Detail',
  	  	component:resolve => require(['@/pages/Detail'],resolve)
  	},
  	//单页
  	{
  	  	path: '/InfoShow',
  	  	name: 'InfoShow',
  	  	component:resolve => require(['@/pages/InfoShow'],resolve)
  	},  
  	//公示区
  	{
  	  	path: '/PublicityList',
  	  	name: 'PublicityList',
  	  	component:resolve => require(['@/pages/Publicity/PublicityList'],resolve)
  	},
  	{
  	  	path: '/PublicityDetail',
  	  	name: 'PublicityDetail',
  	  	component:resolve => require(['@/pages/Publicity/PublicityDetail'],resolve)
  	}, 
	//勤工助学
	{
		path: '/JobList',
		name: 'JobList',
		component:resolve => require(['@/pages/Job/JobList'],resolve)
	},
	{
		path: '/JobDetail',
		name: 'JobDetail',
		component:resolve => require(['@/pages/Job/JobDetail'],resolve)
	}, 
  	//下载页面
  	{
  	  	path: '/DownLoad',
  	  	name: 'DownLoad',
  	  	component:resolve => require(['@/pages/DownLoad'],resolve)
  	},
  
  	{
  	  	path: '/NotFound',
  	  	name: 'NotFound',
  	  	component:resolve => require(['@/pages/NotFound'],resolve)
  	},
  	{
  	  	path: '/NotFound4',
  	  	name: 'NotFound4',
  	  	component:resolve => require(['@/pages/NotFound4'],resolve)
  	},
  	{
  	  	path: '/NotFound5',
  	  	name: 'NotFound5',
  	  	component:resolve => require(['@/pages/NotFound5'],resolve)
  	},
]
const router =new Router({
  	// mode:'history',
  	routes, 
  	// base: "/" + document.location.pathname.split('/')[1] + "/"
});
export default router


// WEBPACK FOOTER //
// ./src/router/index.js